import { Outlet, createRootRoute } from '@tanstack/react-router'
import { AuthProvider } from '../shared/auth/auth-context'
import { RouteError } from '@lunary/ui-web/screen-state'
import { Shell } from '../shared/ui/shell'

export const rootRoute = createRootRoute({
  component: () => (
    <AuthProvider>
      <Shell>
        <Outlet />
      </Shell>
    </AuthProvider>
  ),
  errorComponent: RouteError,
})
